import { Divider } from "../components/divider";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean =>
  __typename === "VinoData_StaticBlock" && staticType === "Divider";

const create = (_data): JSX.Element => {
  return <Divider />;
};

export default { test, create };
